import { WinSpinePopup } from "./WinSpinePopup";

export class FreeSpinOutroPopup extends WinSpinePopup {
    constructor({ totalWin, total, ...parameters }) {
        super({
            ...parameters,
            spine: "freeSpinOutro",
            winValueSlotName: ["win_summ_1"],
            win: totalWin,
            isCounter: true,
            staticValues: [
                { style: "WinPopupCounterStyle", slot: "win_summ_2", value: total },
            ],
            sequence: [
                { animation: "in", sfx: { name: "fs_award_popup" } },
                { animation: "loop", loop: 4 },
                { animation: "out" },
            ],
        });
    }
}
